
























import Vue from 'vue'
import { PartnerServiceContract } from '@/types/generated/graphql'
import XCard from '@/components/atoms/Card/XCard.vue'

type Props = {
  partnerServiceContract: PartnerServiceContract
}

export default Vue.extend<{}, {}, {}, Props>({
  name: 'PartnerServiceContract',
  components: { XCard },
  props: {
    partnerServiceContract: { type: Object },
  },
  computed: {
    styles() {
      return {
        background:
          this.partnerServiceContract.servicePlan?.primaryColor || '#f7b200',
      }
    },
  },
})
